import { RemoteGetListProfile } from 'data/usecases';
import { GetListProfileUseCaseInterface } from 'domain/usecases';
import { makeProfilesAssociated } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetListProfile = (): GetListProfileUseCaseInterface =>
  new RemoteGetListProfile(makeProfilesAssociated(), makeAxiosHttpClient());
